import axios from 'axios';
import BoxWrapper from 'blocks/BoxWrapper';
import Button, { ButtonWrapper } from 'blocks/Button';
import Card from 'blocks/Card';
import Col from 'blocks/Col';
import { RowItem } from 'blocks/Row';
import { Title } from 'blocks/Text';
import { TextField } from 'components/Form';
import Paths from 'helper/paths';
import { useQueryParams } from 'hooks/useQueryParams';
import Auth from 'layouts/Auth';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import urls from 'utils/urls';
import { ResetPasswordInterface } from './resetPassword.interface';
import * as S from './resetPassword.styles';

const ResetPassword = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const query = useQueryParams();

  const { register, getValues } = useForm<ResetPasswordInterface>();

  const reset = () => {
    setLoading(true);
    axios
      .patch(
        urls.forgotPassword,
        { newPassword: getValues('password') },
        { headers: { authorization: `Bearer ${query.get('token')}` } }
      )
      .then((res) => {
        if (res.status === 200) {
          navigate(Paths.Login.index().route);
        }
      })
      .catch((ex) => {
        toast.error(ex?.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const SideFooter = () => {
    return (
      <>
        {t('pages.resetPassword.sections.image.signupDescription')}
        <Link to={Paths.Login.index().route}>{t('pages.resetPassword.sections.image.toLoginCTA')}</Link>;
      </>
    );
  };

  const ResetForm = () => {
    return (
      <S.Wrapper as={RowItem}>
        <S.LoginLoginBox as={Col} align="stretch">
          <Card space="lg">
            <Col align="stretch">
              <S.LoginTitleLeft as={Title} size="medium" bold={false}>
                {t('pages.resetPassword.sections.form.title')}
              </S.LoginTitleLeft>

              <BoxWrapper>
                <TextField
                  type="password"
                  control={register('password')}
                  label={t('pages.resetPassword.sections.form.fields.newPassword.label')}
                />
              </BoxWrapper>

              <BoxWrapper>
                <TextField
                  type="password"
                  control={register('repeatPassword')}
                  label={t('pages.resetPassword.sections.form.fields.repeatPassword.label')}
                />
              </BoxWrapper>

              <S.LoginButton as={ButtonWrapper} justify="center">
                <Button width={176} type="button" onClick={reset} loading={loading}>
                  {t('pages.resetPassword.sections.form.actionButton')}
                </Button>
              </S.LoginButton>
            </Col>
          </Card>
        </S.LoginLoginBox>
      </S.Wrapper>
    );
  };

  return (
    <Auth
      topTitle={t('pages.resetPassword.sections.image.topTitle')}
      title={t('pages.resetPassword.sections.image.title')}
      children={ResetForm()}
      sideFooter={SideFooter()}
    />
  );
};

export default ResetPassword;
